module.exports = __webpack_public_path__ + "static/media/MacLean2014Cover.c9887b0e.png";